// extracted by mini-css-extract-plugin
export default {"resLogo":"NavBar_resLogo__Gg9+E","navStile":"NavBar_navStile__CAzZN","navStiles":"NavBar_navStiles__EXenQ","class":"NavBar_class__zi8ZU","navSticky":"NavBar_navSticky__owXdY"};